export const FETCH_LOTTO5_CONFIGS = "FETCH_LOTTO5_CONFIGS";